// import { ThunkAction } from 'redux-thunk';
// import { RootState } from '..';
// import { newsDataAction } from './types';
import { getNewsDataAsync } from './actions';
import { getNewsList } from '../../api/api';
import createAsyncThunk from '../../lib/createAsyncThunk';

export const getNewDataThunk = createAsyncThunk(getNewsDataAsync, getNewsList)